import { z } from 'zod';
import { CHART_NAME_MAX_LENGTH } from '../../../config/constants';

const scratchpadTitleStringSchema = z
  .string()
  .nonempty('Title cannot be empty')
  .max(
    CHART_NAME_MAX_LENGTH,
    `Title cannot exceed ${CHART_NAME_MAX_LENGTH} characters.`,
  )
  .superRefine((value, ctx) => {
    if (value.length > 0 && value.trim().length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Title cannot be all whitespaces.',
        fatal: true,
      });

      return z.NEVER;
    }
  });

export const scratchpadTitleSchema = z.object({
  value: scratchpadTitleStringSchema,
});
